import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      setMessage('Thank you for subscribing!');
      setEmail('');
      setIsSubmitting(false);
      
      setTimeout(() => {
        setMessage('');
      }, 3000);
    }, 1000);
  };

  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-wrapper">
          <div className="newsletter-content">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="newsletter-text">
                  <div className="newsletter-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <h2 className="newsletter-title">Subscribe to Our Newsletter</h2>
                  <p className="newsletter-description">
                    Get exclusive digitizing tips, special offers, and the latest updates delivered straight to your inbox.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <form className="newsletter-form" onSubmit={handleSubmit}>
                  <div className="input-group">
                    <input
                      type="email"
                      className="form-control newsletter-input"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={isSubmitting}
                    />
                    <button 
                      type="submit" 
                      className="btn btn-primary newsletter-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Subscribing...
                        </>
                      ) : (
                        <>
                          Subscribe Now
                          <i className="fas fa-paper-plane ms-2"></i>
                        </>
                      )}
                    </button>
                  </div>
                  {message && (
                    <div className="newsletter-message">
                      <i className="fas fa-check-circle me-2"></i>
                      {message}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
          
          {/* Decorative Elements */}
          <div className="newsletter-decoration newsletter-decoration-1">
            <div className="decoration-circle"></div>
          </div>
          <div className="newsletter-decoration newsletter-decoration-2">
            <div className="decoration-circle"></div>
          </div>
          <div className="newsletter-decoration newsletter-decoration-3">
            <div className="decoration-dots">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;